import { IconHP } from 'legacy/lut/assets/img/icons/IconHP'
import { sprPrivacyText } from 'legacy/shared/texts'
import React, { useContext, useEffect, useMemo } from 'react'
import sanitize from 'sanitize-html'

import { Button } from 'core-components/library/button'
import { Dropdown } from 'core-components/library/dropdown'
import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { LanguageContext } from 'onboarding/context/LanguageContext'

import styles from './APLPageLayout.module.scss'

type Props = {
  children: React.ReactNode
  isLoading: boolean
  setIsLoading: (value: boolean) => void
}

const languages = [
  { id: 'en', value: 'English' },
  { id: 'de-DE', value: 'Deutsch' },
  { id: 'es-ES', value: 'Español' },
  { id: 'fr-FR', value: 'Français' },
  { id: 'it-IT', value: 'Italiano' },
  { id: 'pt-PT', value: 'Português' },
]

export function APLPageLayout({ setIsLoading, isLoading, children }: Props) {
  const { setLanguage, language, translationIsLoading } = useContext(LanguageContext)

  useEffect(() => {
    setLanguage(localStorage.getItem('spr_language') || 'en')
  }, [setLanguage])

  useEffect(() => {
    setIsLoading(translationIsLoading)
  }, [setIsLoading, translationIsLoading])

  const localeCrud = useMemo(() => {
    return new Crud({
      fetcher: new Static(languages),
      keyField: 'id',
    })
  }, [])

  const handleLanguageChange = (id: string) => {
    setLanguage(id)
    localStorage.setItem('spr_language', id)
  }

  return (
    <div className={styles.root}>
      <header className={styles.header}>
        <div className={styles.leftSide}>
          <div className={styles.logo}>
            <IconHP className={styles.logoIcon} />
          </div>
          <div>
            <Button color={'grey'} to={'/apl_documents_history'}>
              Documents archive
            </Button>
          </div>
        </div>
        <Dropdown
          classes={{ controlClasses: { root: styles.languageDropdown } }}
          renderFunction={(item) => {
            return <div className={styles.languageDropdown}>{item.value}</div>
          }}
          disabled={isLoading}
          source={localeCrud}
          value={language}
          caption="value"
          onChange={handleLanguageChange}
          label="Language"
        />
      </header>
      <div className={styles.divider} />
      <div className={styles.body}>{children}</div>
      <div className={styles.divider} />
      <footer className={styles.footer}>
        <div className={styles.logo}>
          <IconHP className={styles.logoIcon} />
        </div>

        <div
          className={styles.privacy}
          dangerouslySetInnerHTML={{ __html: sanitize(sprPrivacyText()) }}
        ></div>
      </footer>
    </div>
  )
}
